import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import { secondsToHms } from '../common/Common';
import { useEffect, useState } from 'react';

const IQ3KouteiBetsuKesanshiki_AdditionalProcess = (props) => {
  const [processInput, setProcessInput] = useState([]);

  const [dandoriTime, setDandoriTime] = useState(0);
  const [dandoriAmt, setDandoriAmt] = useState(0);

  const [sagyoTime, setSagyoTime] = useState(0);
  const [sagyoAmt, setSagyoAmt] = useState(0);

  const mSetHRate = props?.deviceMst?.details?.charges.prep;

  const mWorkHRate = props?.deviceMst?.details?.charges.work;

  // 重量
  const weight = props?.data?.weight;
  // 面積
  const area = Number(props?.data?.totalSurfaceArea);

  useEffect(() => {
    let processInput = props?.data?.processInput?.filter((item) => item.processId == props?.processMst?.id)[0];
    if (processInput) {
      setProcessInput(processInput);
    }

    calculateProcessData();
  }, [props?.data]);

  const calculateProcessData = () => {
    // 工程パターンから計算する工程を取得
    let usedCalProcessSelect = props?.data?.processSelect
      ? props?.data?.processSelect?.details?.filter((item) => item.isUsedForCalc)
      : [];
    let patternInfoFilter = [];
    let processMstFilter = [];

    patternInfoFilter = usedCalProcessSelect[0];

    let deviceMstFilter = props?.parameters?.device
      ? props?.parameters?.device?.filter(
          (item) => patternInfoFilter?.processId == item.processId && patternInfoFilter?.deviceId == item.id
        )
      : [];

    // 段取時間設定
    //　基本段取時間＊サイズ係数
    // let dandoriTimeSec = calDandoriTime(deviceMstFilter[0], weight, area);
    let dandoriTimeSec = 0;

    setDandoriTime(dandoriTimeSec);

    let dandoriAmt = calDandoriAmt(dandoriTimeSec, deviceMstFilter[0]);
    setDandoriAmt(dandoriAmt);
  };

  const calDandoriTime = (deviceMst, weight, area) => {
    if (deviceMst == undefined || deviceMst?.length == 0) return 0;
    // 段取時間設定
    // 重量
    let childPartsCoeffWeightThMaster = deviceMst?.details?.childPartsCoeffWeightThMaster?.filter(
      (item) => (item.value == weight || item.value > weight) && !item.isOutOfRange
    );
    // 面積
    let childPartsCoeffAreaThMaster = deviceMst?.details?.childPartsCoeffAreaThMaster?.filter(
      (item) => (item.value == area || item.value > area) && !item.isOutOfRange
    );
    let childPartsCoeffs =
      childPartsCoeffWeightThMaster?.length > 0 && childPartsCoeffAreaThMaster?.length > 0
        ? deviceMst?.details?.childPartsCoeff?.filter((item) => item.weightId == childPartsCoeffWeightThMaster[0]?.no)
        : deviceMst?.details?.childPartsCoeff[0];

    // サイズ係数
    let partsCoeff =
      childPartsCoeffs?.length > 0
        ? childPartsCoeffs?.[0]?.areaCoeffList?.filter(
            (item) => item.no == childPartsCoeffAreaThMaster?.[0]?.no && !item.isOutOfRange
          )?.[0]?.value
        : childPartsCoeffs?.[0]?.areaCoeffList?.[0]?.value;

    //　基本段取時間＊サイズ係数
    let dandoriTimeSec = deviceMst?.details?.prepBasicTime * partsCoeff;
    dandoriTimeSec = dandoriTimeSec ? dandoriTimeSec : 0;
    //dandoriTimeSec = dandoriTimeSec * getSetupCoeff(deviceMst); // IQX_WEBEST-278 基本段取時間＊段取個数係数
    return dandoriTimeSec;
  };

  const calDandoriAmt = (dandoriTimeSec, deviceMst) => {
    if (deviceMst == undefined) return 0;
    //段階時間
    let mSetTimeMin = dandoriTimeSec / 60;
    //装置の段階時間チャージ
    let mSetHRate = deviceMst?.details?.charges.prep;
    //段階時間＊時間チャージ
    let dandoriAmt = (mSetTimeMin * mSetHRate) / 60.0;
    dandoriAmt = dandoriAmt ? dandoriAmt : 0;
    return dandoriAmt;
  };

  return (
    <div className="kouteiCalculateDiv" id="kouteiCalculateDivID">
      <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
        <Col span={4} style={{ paddingLeft: 40, paddingTop: 10 }}>
          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'段取時間'}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'段取金額'}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'加工時間'}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'加工金額'}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'箇所/委託'}</label>
          </div>
        </Col>
        <Col span={12} style={{ marginLeft: 5, paddingTop: 10 }}>
          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'基本段取時間'}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'段取時間(秒) x 段取時間チャージ/3600(秒)'}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'1要素当たりの作業時間ｘ要素数ｘ作業時間係数'}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'加工時間(秒) x 加工時間チャージ/3600(秒)'}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'箇所/委託'}</label>
          </div>
        </Col>
        <Col span={7} style={{ marginLeft: 5, paddingTop: 10 }}>
          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{`${dandoriTime} (${secondsToHms(dandoriTime)})`}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{`(${dandoriTime} × ${mSetHRate}) ÷ 3600 = ${dandoriAmt}`}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{`${sagyoTime} (${secondsToHms(sagyoTime)})`}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{`(${sagyoTime} × ${mWorkHRate}) ÷ 3600 = ${sagyoAmt}`}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{`${1}`}</label>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default IQ3KouteiBetsuKesanshiki_AdditionalProcess;
